let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("izosY")).then(() => parcelRequire('697Tr'));